<template>
    <ui-accordion title="Lista de Documentos e Contratos" @input="openIframe('open-accordion')">
        <div v-if="loader.body" class="loading">
            <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
            <small>{{ loader.message }}</small>
        </div>

        <div v-else class="contents">
            <div class="options-content">
                <div class="display">
                    <ui-button-group :buttons="tabs" :set-button="setButton" @input="changeTable" />
                </div>
                <div v-if="contractsFeaturesIsAllowed" class="others-options">
                    <div class="loading">
                        <ui-load-indicator
                            v-if="loader.warning"
                            :h="20"
                            :stroke="8"
                            bg-color="#e7e9f4"
                            color="#69D296"
                        />
                    </div>
                    <div v-if="showActions" :class="actionsClass">
                        <ui-button
                            :disabled="actionsDisabled"
                            design="success md"
                            @click="multipleModelGeneratePDFHandler(selectedModels)"
                        >
                            Gerar PDF
                        </ui-button>
                        <!-- <ui-select-2
                            v-model="currentActionComputed"
                            :data="properActions"
                            :search="false"
                            :disabled="actionsDisabled"
                            design="default"
                            item-label="name"
                            return-value="name"
                        /> -->
                    </div>
                    <div v-if="showCreateFlowr" class="create-overflow">
                        <ui-button
                            :disabled="createFlowrDisabled"
                            design="success md"
                            @click="createFlowr"
                        >
                            Criar fluxo de assinatura
                        </ui-button>
                    </div>
                </div>
            </div>

            <div class="content" :class="contentClass">
                <list-models
                    :deal-id="dealId"
                    :selected-models.sync="selectedModels"
                    :class="{ 'content-frame-animation': openTab != 'Modelos' }"
                    class="content-frame"
                />
                <contracts-in-pdf
                    :deal-id="dealId"
                    :selected-contracts-sync.sync="selectedContracts"
                    :class="{ 'content-frame-animation': openTab != 'Documentos e Contratos' }"
                    :enabled-features="enabledFeatures"
                    class="content-frame"
                    @input="changeTable"
                />
                <flowr-subscribs
                    :deal-id="dealId"
                    :data="flowList"
                    :class="{ 'content-frame-animation': openTab != 'Fluxos' }"
                    class="content-frame"
                    @reload="loadFlowList"
                />
            </div>
        </div>

        <!-- <ui-modal-message
			name="contracts-layout-delete-action"
			title="Deseja realmente executar a ação de exclusão?"
			text="Cuidado, esta ação não poderá ser desfeita."
			btn-type="danger"
			btn-text="Confirmar"
			icon="fal fa-trash-alt"
			color-circle="danger"
			icon-circle
		/> -->
    </ui-accordion>
</template>

<script>
	// import { uiSelect2 } from '@/components/ui/form'
	import { uiButton, uiButtonGroup } from '@/components/ui/buttons'
	import { uiAccordion } from '@/components/ui/accordion'
	import { uiLoadIndicator } from '@/components/ui'
	import listModels from '../list-models'
	import flowrSubscribs from '../flowr-subscribs'
	import contractsInPdf from '../contracts-in-pdf'

	import { files, deal, digitalSignature, configuration } from '@/services/axios'

	import { mapActions, mapGetters } from 'vuex'

	const workflowStatus = {
		0: 'Rascunho',
		1: 'Aguardando Assinatura',
		2: 'Cancelado',
		3: 'Expirado',
		4: 'Processando',
		5: 'Rejeitado',
		6: 'Assinado',
		200: 'Não iniciado',
		sent: 'Enviado',
		created: 'Criado',
		completed: 'Concluído',
		draft: 'Rascunho',
		running: 'Em execução',
		closed:  'Fechado',
		canceled: 'Cancelado',
		delivered: 'Entregue',
		signed: 'Assinado',
		declined: 'Rejeitado',
		timedout: 'Expirado',
		voided: 'Anulado',
		deleted: 'Removido'
	}

	export default {
		name: 'contracts-layout',

		components: {
			uiButton,
			// uiSelect2,
			uiLoadIndicator,
			uiButtonGroup,
			uiAccordion,
			listModels,
			flowrSubscribs,
			contractsInPdf,
		},

		props: {
			dealId: {
				type: Number,
				default: undefined,
			},
		},

		data() {
			return {
				openContent: false,
				allChecked: false,
				setButton: null,
				tabs: ['Fluxos', 'Documentos e Contratos', 'Modelos'],
				openTab: 'Fluxos',

				// actions: [],
				currentAction: null,
				loader: {
					warning: false,
					body: false,
					message: ''
				},

				selectedModels: [],
				selectedContracts: [],
				flowList: [],

				multipleContractDownloadHandlerBusy: false,
				multipleContractRemoveHandlerBusy: false,
				multipleModelGeneratePDFHandlerBusy: false,
				multipleModelDownloadHandlerBusy: false,

				contractSettingsConfig: null,
				contractsFeaturesIsAllowed: false,
				configurations: {
					digital_signature: null,
					menu_allowed: null,
					contract_settings: null
				},
				enabledFeatures: {
					digital_signature: true,
					contracts: true,
				}
			}
		},

		computed: {
			...mapGetters({
				user: 'auth/getUser',
				integration: 'digitalSignatureStore/getIntegration',
				product: 'digitalSignatureStore/getProduct'
			}),

			/**
			 * Computed property para tratar a seleção de ações no select
			 */
			currentActionComputed: {
				get() {
					return this.currentAction
				},
				set(value) {
					// Emite o evento do Google Analytics
					this.$gtm.trackEvent({
						event: 'fac_button_click',
						category: 'vue-selecione-opções',
						action: 'click',
						label: 'Selecione uma Opção'
					})

					if (value === this.currentAction || !value) return

					let category = ''
					let label = ''
					switch (value) {
						case 'Baixar Contrato':
							category = 'vue-baixar-contrato-opcoes'
							label = 'Baixar Contrato Opções'

							this.multipleContractDownloadHandler(this.selectedContracts)

							// Clear selected contracts
							this.$root.$emit('select-all-contract-in-pdf', false)
							this.currentAction = null
							break

						case 'Excluir Contrato':
							category = 'vue-excluir-contrato-opcoes'
							label = 'Excluir Contrato Opções'

							this.multipleContractRemoveHandler(this.selectedContracts)

							// Clear selected contracts
							this.$root.$emit('select-all-contract-in-pdf', false)
							this.currentAction = null
							break

						case 'Gerar PDF':
							category = 'vue-gerar-pdf-opcoes'
							label = 'Gerar PDF Opções'

							this.multipleModelGeneratePDFHandler(this.selectedModels)

							// Clear selected contracts
							this.$root.$emit('contract-selected-models--all', false)
							this.currentAction = null
							break

						case 'Baixar Documento':
							category = 'vue-baixar-documento-opcoes'
							label = 'Baixar Documento Opções'

							this.multipleModelDownloadHandler(this.selectedModels)

							// Clear selected contracts
							this.$root.$emit('contract-selected-models--all', false)
							this.currentAction = null
							break
					}

					// Emite o evento do Google Analytics
					this.$gtm.trackEvent({ event: 'fac_button_click', category, action: 'click', label })
				}
			},

			showActions() {
				return ['Modelos'].includes(this.openTab)
			},

			actionsClass() {
				let onModels = this.openTab == 'Modelos'
				return {
					actions: onModels,
				}
			},

			properActions() {
				return [
					{
						name: 'Gerar PDF',
					}
				]
			},
			/**
			 * Computed property que define se o botão Criar fluxo de assinatura irá aparecer
			 * na aba de Documentos e Contratos
			 */
			showCreateFlowr() {
				return this.openTab == 'Documentos e Contratos' && this.enabledFeatures.digital_signature
			},

			contentClass() {
				let onFlowrs = this.openTab == 'Fluxos'
				return {
					margin: onFlowrs,
				}
			},

			createFlowrDisabled() {
				return this.selectedContracts.length > 0 ? false : true
			},

			actionsDisabled() {
				if (this.openTab == 'Modelos') return !this.selectedModels.length > 0
				if (this.openTab == 'Documentos e Contratos') return !this.selectedContracts.length > 0

				return true
			},
		},

		async created() {
			await this.loadConfigurations()
			// Verify if user_group is allowed to use contracts features
			this.verifyContractsFeaturesIsAllowed()
			await this.loadFlowList()
		},

		async mounted() {

			// Continue normal flow
			this.openIframe('closed-modal')

			this.$root.$on('contracts-loading-warning', (value) => {
				this.loader.warning = value
			})

			this.$root.$on('request-contracts-features-is-allowed', () => {
				this.$root.$emit('contracts-features-is-allowed', this.contractsFeaturesIsAllowed)
			})

			this.$root.$on('contract-generate-from-model', async (payload) => {
				if (!payload) {
					this.$toastr.e('O ID do modelo selecionado é inválido')
					return
				}

				// Init loading action warning
				this.loader.warning = true

				await this.multipleModelGeneratePDF(payload, this.dealId)

				// Close loading action warning
				this.loader.warning = false

				// Refresh contracts list to view new contract
				this.$root.$emit('refresh-contracts-list')

				// Activate actions again
				this.$root.$emit('model-set-actions-status', { model_id: payload, status: false })
			})
		},

		beforeDestroy() {
			this.$root.$off('contracts-loading-warning')
			this.$root.$off('request-contracts-features-is-allowed')
			this.$root.$off('contract-generate-from-model')
		},

		methods: {
			...mapActions('digitalSignatureStore', [
				'setProduct',
				'setIntegration'
			]),
			changeTable(val, set) {
				let category = ''
				let label = ''
				this.openTab = val
				this.setButton = val ? null : set

				switch(val) {
					case 'Fluxos':
						category = 'vue-aba-fluxos'
						label = 'Aba Fluxos'
						break

					case 'Documentos e Contratos':
						category = 'vue-aba-contratos'
						label = 'Aba Contratos'
						break

					case 'Modelos':
						category = 'vue-aba-modelos'
						label = 'Aba Modelos'
						break
				}

				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({ event: 'fac_button_click', category, action: 'click', label })
			},
			/**
			 * Cria e emite um evento customizado para abrir um modal em um Iframe do painel
			 * Legado
			 */
			openIframe(name, data = null) {
				let event = new CustomEvent(`iframe--contracts-${name}`, { detail: data })

				window.parent.document.dispatchEvent(event)
			},
			/**
			 * Solicita o cadastro de um fluxo, de acordo com os parâmetros de aquivo,
			 * negócio e integração configurados
			 */
			createFlowr() {
				// Não permite a criação de fluxos, sem uma integração configurada
				if (!this.integration?.slug) return

				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-criar-fluxo',
					action: 'click',
					label: 'Criar Fluxo de Assinatura'
				})

				// Monta os parâmetros necessários para abrir o modal
				const data = {
					files: this.selectedContracts,
					deal_id: this.dealId,
					integration: this.integration?.slug.replace('_', '-'),
					slug: this.integration?.slug,
					integration_id: this.integration?.id
				}

				this.openIframe('signing-flow', data)
				// this.openIframe('new', data)
			},

			async getFileDetails(fileId) {
				try {
					const { data } = await files.get('', fileId)
					return data
				} catch {
					return null
				}
			},

			async multipleContractDownload(fileId) {
				const fileData = await this.getFileDetails(fileId)
				window.open(fileData.url)
			},

			async multipleContractDownloadHandler(selectedContracts) {
				if (this.multipleContractDownloadHandlerBusy || selectedContracts.length === 0)
					return

				this.multipleContractDownloadHandlerBusy = true

				// Make action for each selected contract
				for await (const contract of selectedContracts) {
					// Init loading action warning
					this.loader.warning = true

					await this.multipleContractDownload(contract)

					// Close loading action warning
					this.loader.warning = false
				}

				this.multipleContractDownloadHandlerBusy = false
			},

			async multipleContractRemove(fileId) {
				try {
					// Delete file from deal and refresh list
					const { data } = await deal.removeFileToDeal(this.dealId, fileId)

					// Show request infos
					if (data.status === 'success') this.$toastr.s(data.msg)
					else this.$toastr.w(data.msg)

					// Refresh contracts list to view the current list
					this.$root.$emit('refresh-contracts-list')
				} catch (error) {
					console.log(error)
				}
			},

			async multipleContractRemoveHandler(selectedContracts) {
				if (this.multipleContractRemoveHandlerBusy || selectedContracts.length === 0) return

				this.multipleContractRemoveHandlerBusy = true

				// Make action for each selected contract
				for await (const contract of selectedContracts) {
					// Init loading action warning
					this.loader.warning = true

					await this.multipleContractRemove(contract)

					// Close loading action warning
					this.loader.warning = false
				}

				this.multipleContractRemoveHandlerBusy = false
			},

			async multipleModelGeneratePDF(id, dealId) {
				const getContractDetails = async () => {
					try {
						await deal.getContractFromModel(id, dealId)
					} catch (error) {
						console.log(error)
					}
				}

				const saveContract = async () => {
					try {
						const { data } = await deal.generateContractFromModel(id, dealId)

						// Show request infos
						if (data.status === 'success') this.$toastr.s(data.msg)
						else this.$toastr.w(data.msg)
					} catch (error) {
						console.log(error)
					}
				}

				await getContractDetails()
				await saveContract()
			},
			/**
			 * Event handler que trata o evento de quando a geração de múltiplos arquivos PDFs
			 * é requerida
			 */
			async multipleModelGeneratePDFHandler(selectedModels) {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-gerar-pdf-opcoes',
					action: 'click',
					label: 'Gerar PDF Opções'
				})

				if (this.multipleModelGeneratePDFHandlerBusy || selectedModels.length === 0) return

				this.multipleModelGeneratePDFHandlerBusy = true

				// Make action for each selected model
				for await (const model of selectedModels) {
					// Init loading action warning
					this.loader.warning = true

					await this.multipleModelGeneratePDF(model.id, this.dealId)

					// Close loading action warning
					this.loader.warning = false

					// Refresh contracts list to view new contract
					this.$root.$emit('refresh-contracts-list')
				}

				this.multipleModelGeneratePDFHandlerBusy = false
			},

			async multipleModelDownload(fileId) {
				const fileData = await this.getFileDetails(fileId)
				window.open(fileData.url)
			},

			async multipleModelDownloadHandler(selectedModels) {
				if (this.multipleModelDownloadHandlerBusy || selectedModels.length === 0) return

				this.multipleModelDownloadHandlerBusy = false

				// Make action for each selected model
				for await (const model of selectedModels) {
					// Init loading action warning
					this.loader.warning = true

					await this.multipleModelDownload(model.file_id)

					// Close loading action warning
					this.loader.warning = false
				}

				this.multipleModelDownloadHandlerBusy = false
			},
			/**
			 * Carrega as configurações necessárias à partir do localStorage
			 */
			loadConfigurations: async function () {
				if (!this.$route?.query?.product_id) return

				try {
					this.loader.body = true
					// Carrega os dados do empreendimento e sua última integração configurada
					let response = await digitalSignature.getAllV2(
						'last-integration',
						{ product_id: this.$route.query.product_id }
					)
					this.setProduct(response.data)
					await this.setIntegration(response.data.digital_signature_integration)

					response = await configuration.getConfig('menuAllowed')
					this.configurations.menu_allowed = [...response.data.value_long]

					// Verifica se o empreendimento possui assinatura digital
					if (this.integration?.id) {
						response = await digitalSignature.getAllV2(
							'configuration',
							{ integration_id: this.integration.id }
						)
						this.configurations.digital_signature = { ...response.data.data }
					}

					response = await configuration.getConfig('contractSettings')
					this.configurations.contract_settings = { ...response.data.value_long }

					// Verifica quais as funcionalidades estão ativas de acordo com as configurações
					this.enabledFeatures = {
						digital_signature: this.configurations.digital_signature?.active
							? parseInt(this.configurations.digital_signature.active)
							: false,
						contracts: this.configurations.menu_allowed.includes('contract')
					}

				} catch (error) {
					console.log(error)
					this.configurations.menu_allowed = null
					this.configurations.digital_signature = null

				} finally {
					this.loader.body = false
				}
			},
			/**
			 * Verifica se o usuário logado possui permissão para utilizar a gestão
			 * de documentos e contratos
			 */
			verifyContractsFeaturesIsAllowed() {
				if (!this.user || !this.configurations.contract_settings) return
				const isDynamicUser = this.user && this.user.isDynamicGroup
				const contractSettings = { ...this.configurations.contract_settings }

				// Check if the user's current group is allowed
				// Support: All Facilita groups and also dynamic users
				this.contractsFeaturesIsAllowed = contractSettings.allowedGroups.includes(this.user.user_group) ||
					(isDynamicUser && contractSettings.allowedGroups.includes('dynamic'))

				this.$root.$emit('contracts-features-is-allowed', this.contractsFeaturesIsAllowed)
			},
			/**
			 * Configura as abas/tabs a serem mostradas de acordo com as configurações
			 * e os fluxos cadastrados
			 */
			setTabs() {
				if (!this.enabledFeatures) return

				/**
				 * Caso não exista nenhum fluxo cadastrado ou a Assinatura Digital esteja
				 * desativada, oculta a aba de Fluxos
				 */
				let index = this.tabs.findIndex(item => item === 'Fluxos')
				if ((!this.flowList.length || !this.enabledFeatures.digital_signature) && index >= 0) {
					this.tabs.splice(index, 1)
				}

				/**
				 * Verifica se a Gestão de Documentos e Contratos está ativa, se não estiver,
				 * oculta a aba de Modelos
				 */
				index = this.tabs.findIndex(item => item === 'Modelos')
				if (!this.enabledFeatures.contracts && index >= 0) {
					this.tabs.splice(index, 1)
				}

				this.openTab = this.tabs[0]
			},
			/**
			 * Retorna um label à partir do status de um fluxo
			 */
			getWorkflowStatus(item) {
				return workflowStatus[item] || 'Desconhecido'
			},
			/**
			 * Monta um fluxo do negócio
			 */
			mountFlow(item) {
				if (item.detail == 'Entity was not found') return

				/** Mount the files of a flow */
				let fileArray = []
				if (item.files) fileArray = [...item.files]

				const newItem = {
					title: item.flow_name ? item.flow_name : 'Sem nome',
					situation: this.getWorkflowStatus(item.status),
					data: { ...item },
					files: fileArray.map(file => ({
						title: file.name,
						historic: file.docIdHref || '',
						download: file.link?.signed || file.link?.original,
						workflowSteps: file.workflowSteps
							? [...file.workflowSteps]
							: []
					})),
					loading: false
				}
				this.flowList.push(newItem)
			},
			/**
			 * Busca todos os fluxos cadastrados no sistema para este negócio
			 */
			loadFlowList: async function () {
				if (!this.integration) return

				try {
					this.$root.$emit('deal-flow-list-load', true)
					this.flowList = []
					const params = {
						deal_id: this.dealId,
						integration_id: this.integration?.id
					}
					const { data } = await digitalSignature.getAllV2('workflow', params)
					// Mount the flow list with proper data
					if (data?.data) data.data.forEach(item => this.mountFlow(item))

				} catch (error) {
					console.log(error)

				} finally {
					this.$root.$emit('deal-flow-list-load', false)
					this.setTabs()
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
